import { render, staticRenderFns } from "./PreviewQuestion.vue?vue&type=template&id=b95c5256"
import script from "./PreviewQuestion.vue?vue&type=script&lang=js"
export * from "./PreviewQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports